import React from 'react';
import { TradingCell } from '@johnlewispartnership/wtr-content-component-library';

import { type Banner } from 'api/definitions/adtech/types';
import { usePromoImpression } from 'hooks/use-promo-impression';
import { EventType, sendAdTechEvent } from 'analytics/gtmServerFunctions';

export type TradingCellWrapperProps = {
  componentId?: string;
  analytics: Partial<Banner['tracking']> & { promoName?: 'citrusAd' };
  position: string;
  products: {
    id: string;
    lineNumber?: string;
  }[];
  isCitrusAd: boolean;
};

const TradingCellWrapper = (props: TradingCellWrapperProps) => {
  const { componentId, analytics, position, products, isCitrusAd } = props;

  const observerRef = usePromoImpression({
    componentId,
    analytics,
    position,
    products,
  });

  const promoClickHandler = () => {
    if (isCitrusAd) {
      sendAdTechEvent({
        eventType: EventType.CLICK,
        sponsorshipId: componentId,
        trackingUrls: analytics?.clickUrls,
        vendor: analytics?.vendor,
      });
    }
  };

  // @ts-expect-error `onPromoClick` property is not declared
  return <TradingCell ref={observerRef} {...props} onPromoClick={promoClickHandler} />;
};

export default TradingCellWrapper;
